<template>
  <div class="component-ready">
    <div>
      <div class="title">准备好了吗？</div>
      <div class="form">
        <div class="btn-try" @click="$login">开始免费试用</div>
        <div class="text">OR</div>
        <div class="btn-appointment" @click="goto">预约专家演示</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ready',
  methods: {
    goto() {
      this.$router.push('/appoint')
    }
  }
}
</script>

<style scoped lang="scss">
  .btn-try:hover{
    cursor: pointer;
  }
  .btn-appointment:hover{
    cursor: pointer;
  }
.component-ready{
  height: 315px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .title{
    font-size: 23px;
    margin-bottom: 30px;
  }
  .form{
    display: flex;
    justify-content: center;
    align-items: center;
    .text{
      padding: 0 20px;
    }
    .btn-try{
      width: 185px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: white;
      border-radius: 5px;
      background-color: #fb7921;
    }
    .btn-appointment{
      width: 185px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: white;
      border-radius: 5px;
      background: #439adf;
    }
  }
}
</style>
